import { Flex, Image, Tag, Text } from "@chakra-ui/react"

type WithdrawalModalTagProps = {
  icon?: string
  children: React.ReactNode
  variant?: "regular" | "small"
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  width?: string
  backgroundColor?: string
  backgroundHoverColor?: string
  isDisabled?: boolean
}

export default function WithdrawalModalTag({
  icon,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children,
  isDisabled = false,
  variant = "regular",
  width = "",
  backgroundColor = "primary.black.5",
  backgroundHoverColor = "primary.black.5",
}: WithdrawalModalTagProps) {
  return (
    <Tag
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      width={width}
      height={variant === "small" ? "24px" : "32px"}
      padding={variant === "small" ? "0 8px 0 0" : "4px 8px"}
      paddingLeft={variant === "small" && !icon ? "8px" : undefined}
      borderRadius={variant === "small" ? "24px" : "48px"}
      bg={backgroundColor}
      opacity={isDisabled ? 0.5 : 1}
      cursor={onClick && !isDisabled ? "pointer" : "default"}
      _hover={{
        bg: backgroundHoverColor,
      }}
    >
      <Flex gap="8px" width="100%">
        {icon && <Image src={icon} />}
        <Text
          variant="body"
          letterSpacing="0.16px"
          flexGrow="1"
          textAlign="center"
        >
          {children}
        </Text>
      </Flex>
    </Tag>
  )
}
